export default __webpack_public_path__ + "static/media/python-project-for-data-science.b8314401.png";